import { useMemo } from "react";
import { ethers } from "ethers";
import { useAccount } from "wagmi";

/**
 * Ethers v5 signer from injected provider (wagmi v2 in this repo does not export useSigner).
 */
export function useEthersSigner() {
  const { address, isConnected } = useAccount();

  return useMemo(() => {
    if (!isConnected || !address || typeof window === "undefined" || !window.ethereum) {
      return null;
    }
    try {
      return new ethers.providers.Web3Provider(window.ethereum, "any").getSigner();
    } catch {
      return null;
    }
  }, [isConnected, address]);
}
